import { closeModalRoute, openModalRoute } from '../../../../dt-plugins/modal/modal.mixin';

export const TravelListMixin = (parent = 'travel_before') => ({
  data: function() {
    return {
      parent: parent,
      // travelFormDialog: false,
      // travelFormContainer: false,
      // travelFormMode: 'edit',
      // selectedTravel: null
    }
  },
  methods: {
    onTravelChange: function({value, name, item}) {
      this.$emit('updated', {
        value, name, item
      });
    },
    onTravelSelected: function(travel) {
      // this.travelFormContainer = true;
      // this.travelFormMode = 'edit';
      // this.selectedTravel = null;


      openModalRoute(this, this.parent, {
        mode: 'edit',
        travel_id: travel.travel_id
      });

      setTimeout(() => {
        // this.travelFormDialog = true;
        
        // BookingService.findTravelDescription({
        //   calendarDateId: this.calendarDateId,
        //   travelId: travel.travel_id
        // }).then(res => {
        //   this.selectedTravel = res.data;
        // });

      }, 0)
    },
    onTravelDelete: function(item) {
      this.$emit('deleted', {
        item
      });
    },
    addTravelClick: function(event) {
      this.openAddTravelDialog();
    },
    onAddTravelCancel: function(event) {
      this.closeAddTravelDialog();
    },
    onTravelSubmit: function({
      mode,
      travel
    }) {
      if (mode === 'add') {
        this.$emit('inserted', {travel});
      } else if (mode === 'edit') {
        this.$emit('edited', {travel});
      }
      this.closeAddTravelDialog();
    },
    openAddTravelDialog: function() {
      // this.travelFormContainer = true;
      // this.travelFormMode = 'add';
      // this.selectedTravel = null;

      setTimeout(() => {
        // this.travelFormDialog = true;
      }, 0);

      openModalRoute(this, this.parent, {
        mode: 'add'
      });
      // if (this.parent === 'travel_before') {
      // } else if (this.parent === 'travel_after') {
      //   openModalRoute(this, 'travel_after', {
      //     mode: 'add'
      //   });
      // }

    },
    closeAddTravelDialog: function() {
      closeModalRoute(this, {
        mode: undefined,
        travel_id: undefined,
      });
      // this.travelFormDialog = false;
      // waitForAnimation(() => {
      //   this.travelFormContainer = false;
      // })
    }
  }
})
